// extracted by mini-css-extract-plugin
export default {"editor":"ColorwayEditor_editor__gASAz","info":"ColorwayEditor_info__0IvX-","colors":"ColorwayEditor_colors__xf01C","description":"ColorwayEditor_description__VFSqi"};